// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y64B","field":"styles_field__HpOeY","fieldCol":"styles_fieldCol__1Je-k","diffCol":"styles_diffCol__18En_","diff":"styles_diff__1f9yN"};